export const STORAGE_KEYS = {
  fcmToken: 'FCM_TOKEN',
  cookiesConsented: 'COOKIES_CONSENTED',
} as const
